<script setup>
import ImportCSV from '@/components/Payroll/ImportCSV.vue';

export default {
    components: { ImportCSV },
    data() {
        return {
            projectTypes: [
                {
                    label: 'Import CSV',
                    name: 'import-csv',
                },
                {
                    label: 'Payroll Generation',
                    name: 'payroll-generation',
                },
                {
                    label: 'Payroll History',
                    name: 'payroll-history',
                },
                {
                    label: 'Metrics',
                    name: 'metrics',
                },
            ],
        };
    },
};
</script>

<template>
    <div>
        <Card>
            <p class="projTitle">PROJECTS</p>
            <div>
                <Tabs v-model="selectedTab" type="card" class="fullwidth pt-tabs" @on-click="handleOnTabChanged">
                    <TabPane label="Import CSV" name="import-csv"><ImportCSV /></TabPane>
                    <TabPane label="Payroll Generation" name="payroll-generation"></TabPane>
                    <TabPane label="Payroll History" name="payroll-history"></TabPane>
                </Tabs>
            </div>
        </Card>
    </div>
</template>

<style scoped lang="scss"></style>
